<style scoped>
  .btn-group {
    padding-left: 20px;
  }
</style>
<template>
  <div class="knowledge_query">
    <RadioGroup size="large" v-model="activeBtn" type="button" style="margin-bottom: 20px;">
      <Radio label="shopReport">商铺报表</Radio>
      <Radio label="contractReport">合同执行情况明细表</Radio>
      <Radio label="costReport">缴费报表</Radio>
      <Radio label="rentReport">租金收入汇总表</Radio>
      <Radio label="incomeReport">收支表</Radio>
    </RadioGroup>
    <Card>
      <shop-report v-show="activeBtn=='shopReport'"></shop-report>
      <cost-report v-show="activeBtn=='costReport'"></cost-report>
      <contract-report v-show="activeBtn=='contractReport'"></contract-report>
      <rent-report v-show="activeBtn=='rentReport'"></rent-report>
      <income-report v-show="activeBtn=='incomeReport'"></income-report>
    </Card>
  </div>
</template>
<script>
  import shopReport from "./component/shop-report.vue";
  import costReport from "./component/cost-report.vue";
  import contractReport from "./component/contract-report.vue";
  import rentReport from "./component/rent-report.vue";
  import incomeReport from "./component/income-report.vue";
  export default {
    name:'reportMain_page',
    data() {
      return{
        activeBtn:'shopReport'
      }
    },
    components: {
      shopReport,
      contractReport,
      costReport,
      rentReport,
      incomeReport
    },
    methods:{

    }
  }
</script>






